// Action Types for Campaign Biases
const IS_LOADING = "campaigns/campaignBias/IS_LOADING";
const CAMPAIGN_BIAS_DATA = "campaigns/campaignBias/CAMPAIGN_BIAS_DATA";
const IS_ERROR = "campaigns/campaignBias/IS_ERROR";

// Exporting the constants
export { IS_LOADING, CAMPAIGN_BIAS_DATA, IS_ERROR };
